import { desvioDoEsperado, type Esperado, type Leitura } from './referencia.js';

/**
 * Como os filhos de um garanhao ou de uma egua costumam sair.
 *
 * Nao da para tirar a media crua da altura dos filhos: um de 8 meses e um de 4
 * anos nao se comparam. Para cada filho, pega-se a ultima ficha e quanto ele
 * esta acima ou abaixo do ESPERADO PARA A IDADE dele (curva de referencia). A
 * media dessas diferencas e a media da prole.
 *
 * E o primeiro passo na direcao da avaliacao genetica que o projeto preve para
 * a Fase 3 (BLUP), que corrige tambem pelo outro genitor e pelo ambiente — esta
 * media nao corrige, e a tela diz isso.
 */

export interface FilhoMedido {
  valor: number;
  esperado: Esperado;
}

/** Minimo de filhos medidos para mostrar a media. Pergunta em aberto ao Rafael. */
export const MINIMO_FILHOS = 3;

export interface ResumoDaProle {
  n: number;
  /** Media de (valor - esperado), na unidade da medida. */
  mediaDaDiferenca: number;
  /** Media dos z de cada filho: a leitura sai daqui. */
  mediaDoZ: number;
  /** Desvio-padrao das diferencas entre os filhos. */
  dp: number;
  leitura: Leitura;
}

/** Resumo da prole numa medida, ou `null` com menos filhos medidos que o minimo. */
export function resumoDaProle(filhos: readonly FilhoMedido[], minimo = MINIMO_FILHOS): ResumoDaProle | null {
  if (filhos.length < minimo) return null;
  const desvios = filhos.map((f) => desvioDoEsperado(f.valor, f.esperado));
  const n = desvios.length;
  const mediaDaDiferenca = desvios.reduce((a, d) => a + d.diferenca, 0) / n;
  const mediaDoZ = desvios.reduce((a, d) => a + d.z, 0) / n;
  const dp = Math.sqrt(desvios.reduce((a, d) => a + (d.diferenca - mediaDaDiferenca) ** 2, 0) / (n - 1));
  // Media de varios filhos: meio desvio-padrao ja e uma tendencia clara.
  const leitura: Leitura = mediaDoZ > 0.5 ? 'acima' : mediaDoZ < -0.5 ? 'abaixo' : 'dentro';
  return { n, mediaDaDiferenca, mediaDoZ, dp, leitura };
}
